import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ApiDebug from './components/ApiDebug';
import './styles/global.css';

function AppRouter() {
  const { isLoggedIn } = useAuth();
  return (
    <>
      {isLoggedIn ? <DashboardPage /> : <LoginPage />}
      <ApiDebug />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
